<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div>
        <div class="rowinfo">
          <v-text-field
            :value="displayValue"
            class="rounded-lg"
            dense
            hide-details
            outlined
            :placeholder="$t('search_name_product')"
            readonly
            @click="dialog = true"
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-selectedproduct-displayValue`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('search_product')"
          />
        </div>

        <custom-popup
          v-model="dialog"
          :close-on-confirm="false"
          :cons="cons"
          reloadable
        >
          <div class="pa-4">
            <vue-table
              v-model="selection"
              :data="list"
              :headers="translatedHeaders"
              show-select
              @change="onPagination"
            >
              <template v-slot:index="{ item }">
                {{ item.index + 1 + (list.current_page - 1) * list.per_page }}
              </template>

              <template v-slot:gallery="{ item }">
                <v-avatar class="ma-2" size="48">
                  <img :alt="item.name" :src="item.gallery | getProductImage" />
                </v-avatar>
              </template>

              <template v-slot:price="{ item }">
                {{ use_lang(price(item.price)) }} {{ $t("currency") }}
              </template>
            </vue-table>
          </div>
        </custom-popup>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "personalProductPicker",

  props: {
    value: Array,
  },

  data() {
    return {
      helpData: [],
      componentName: "personalProductPicker",
      serviceName: "Qrland",

      cons: {
        title: "",
        buttons: [
          { type: "reload", handler: this.fetchProducts },
          { type: "submit", handler: this.submit },
        ],
      },
      dialog: false,
      list: {},
      loading: false,
      headers: [
        {
          value: "index",
          text: "headers.index",
          sortable: false,
          align: "center",
        },
        {
          value: "gallery",
          text: "headers.gallery",
          sortable: false,
          align: "center",
        },
        { value: "id", text: "headers.id", sortable: false, align: "center" },
        {
          value: "name",
          text: "headers.name",
          sortable: false,
          align: "center",
        },
        {
          value: "brand",
          text: "headers.brand",
          sortable: false,
          align: "center",
        },
        {
          value: "price",
          text: "headers.price",
          sortable: false,
          align: "center",
        },
        {
          value: "discount_amount",
          text: "headers.discount_amount",
          sortable: false,
          align: "center",
        },
      ],
      selection: [],
      tableProps: {
        length: 30,
        page: 1,
      },
    };
  },

  computed: {
    ...mapState("localstorage", ["createQrID"]),
    displayValue() {
      let arr = [];
      if (this.value instanceof Array) arr = this.value;

      return [...this.selection.map((item) => item.id), ...arr].join(", ");
    },
    translatedHeaders() {
      return this.headers.map((header) => ({
        ...header,
        text: this.$t(header.text),
      }));
    },
  },

  created() {
    this.fetchProducts();
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    fetchProducts() {
      this.loading = true;

      this.$api
        .get("/v1/testQr/find-product/", {
          params: {
            qr_id: this.createQrID,
          },
        })
        .then(({ data }) => (this.list = data.data))
        .catch(({ response }) =>
          console.log("failed to get products list: ", response)
        )
        .finally(() => (this.loading = false));
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.fetchProducts(props);
    },
    submit() {
      this.$emit("submit", this.selection);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
:deep(.v-application--is-rtl) {
  direction: rtl;
}
</style>
